import { Popover } from "antd";
import React from "react";
import LocalizationUtil from "../../../localization/LocalizationUtil";
import CommonUtil from "../../../utils/CommonUtil";
import { constants } from "../../../utils/Constants";
import SecurityUtils from "../../../utils/SecurityUtils";

class TableUtils {
  static idFormatter = (cell, row, rowIndex, formatExtraData) => {
    return this.textFormatter(cell, row, rowIndex, formatExtraData, true);
  };

  static selectableTextFormatter = (
    cell,
    row,
    rowIndex,
    formatExtraData,
    isIdColumn = false
  ) => {
    return TableUtils.formatText(
      cell,
      row,
      rowIndex,
      formatExtraData,
      isIdColumn,
      true
    );
  };

  static textFormatter = (
    cell,
    row,
    rowIndex,
    formatExtraData,
    isIdColumn = false
  ) => {
    return TableUtils.formatText(
      cell,
      row,
      rowIndex,
      formatExtraData,
      isIdColumn
    );
  };

  static formatText = (
    cell,
    row,
    rowIndex,
    formatExtraData,
    isIdColumn = false,
    selectable = false
  ) => {
    let className = "column";

    if (selectable) {
      className = `${className} selectable`;
    }

    if (row[constants.NEW_ELEMENT_INDICATOR_PROPERTY]) {
      className = `${className} newTableRow`;

      if (isIdColumn) {
        cell = "+";
      }
    }

    row = formatExtraData?.entitySelector
      ? CommonUtil.getDeep(row, formatExtraData.entitySelector)
      : row;

    if (row && constants.KNOWLEDGE_ENTITY_TYPE === row["type"]) {
      if (
        !SecurityUtils.partyHasPermissionOnEntity(row, constants.OPERATION_READ)
      ) {
        className = `${className} nonselectableTableRow`;
      }
    }

    if (row.active || row.active === false) {
      className = row.active ? className : `${className} deletedTableRow`;
    } else if (row.read || row.read === false) {
      className = row.read ? className : `${className} unread-message-table`;
    }

    return (
      <Popover
        content={cell}
        placement="topLeft"
        overlayClassName={formatExtraData?.overlayClassName}
      >
        <div className={className}>{cell}</div>
      </Popover>
    );
  };

  static dateFormatter = (cell, row, rowIndex, formatExtraData) => {
    const formattedDate = LocalizationUtil.localDateTime(cell);
    return this.textFormatter(formattedDate, row, rowIndex, formatExtraData);
  };

  static textFilter = (
    placeholder,
    comparator,
    defaultValue,
    className = "table-filter",
    delay = 700 // react bootstrap table 2 default is 500ms
  ) => {
    return {
      type: "text",
      placeholder: placeholder,
      comparator: comparator,
      className: className,
      delay: delay,
      defaultValue: defaultValue
    };
  };
}
export default TableUtils;
